import { Component, OnInit, Inject } from '@angular/core';
import { OperationsProposalDetailModel, FunctionalityEcommerceEnum, OpportunityTypeEnum, ProviderTefEnum, EcommerceTechTypeEnum } from '../../models/operations-proposal-details.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OperationProposalService } from '../../services/operation-proposal.service';

@Component({
    selector: 'app-operations-proposal-detail',
    templateUrl: './operations-proposal-detail.component.html',
    styleUrls: ['./operations-proposal-detail.component.scss'],
    standalone: false
})
export class OperationsProposalDetailComponent implements OnInit {

  model: OperationsProposalDetailModel;
  public EcommerceTechTypeEnum = EcommerceTechTypeEnum;

  constructor(private dialogRef: MatDialogRef<OperationsProposalDetailComponent>,
    private operationProposalService: OperationProposalService,
    @Inject(MAT_DIALOG_DATA) public response: OperationsProposalDetailModel,
  ) { }

  ngOnInit() {
    this.model = this.response;
    if (this.model && this.model.eCommerceDetails) {
      this.model.eCommerceDetails.forEach((item, index) => {
        if (!item.technologyType) {
          item.technologyType = EcommerceTechTypeEnum.OLD;
        }
      });
    }
  }

  getDay(item: string) {
    switch (item) {
      case 'MONDAY':
        return 'Segunda-feira'
      case 'TUESDAY':
        return 'Terça-feira'
      case 'WEDNESDAY':
        return 'Quarta-feira'
      case 'THURSDAY':
        return 'Quinta-feira'
      case 'FRIDAY':
        return 'Sexta-feira'
      case 'SATURDAY':
        return 'Sábado'
      case 'SUNDAY':
        return 'Domingo'
    }
  }

  getProspectionText(item: OpportunityTypeEnum) {
    switch (item) {
      case OpportunityTypeEnum.ALREADY_CUSTOMER:
        return 'EC já é cliente';

      case OpportunityTypeEnum.BANK_COOPERATIVE:
        return 'Banco/Cooperativa';

      case OpportunityTypeEnum.FACE_TO_FACE:
        return "Captação presencial";

      case OpportunityTypeEnum.PARTNER:
        return "Parceiro";

      case OpportunityTypeEnum.TELEMARKETING:
        return "Telemarketing";
    }
  }

  getFunctionalitiesText(functionality: FunctionalityEcommerceEnum) {
    switch (functionality) {
      case FunctionalityEcommerceEnum.LINK_PAYMENT:
        return 'Link de pagamento';

      case FunctionalityEcommerceEnum.SPLIT_PAYMENT:
        return 'Split de pagamento';

      case FunctionalityEcommerceEnum.RECURRENCE:
        return "Recorrência";

      case FunctionalityEcommerceEnum.VIRTUAL_STORE:
        return "Loja virtual";

      case FunctionalityEcommerceEnum.ANTI_FRAUD:
        return "Antifraude";

      case FunctionalityEcommerceEnum.THREE_DS:
        return "3DS";

      case FunctionalityEcommerceEnum.TOKENIZATION:
        return "Tokenização";
    }
  }

  getProviderTefText(providerTef: ProviderTefEnum) {
    switch (providerTef) {
      case ProviderTefEnum.CTF:
        return 'CTF';

      case ProviderTefEnum.DIRECTION:
        return 'DIRECTION';

      case ProviderTefEnum.PAY_AND_GO:
        return 'PAY & GO';

      case ProviderTefEnum.SCOPE:
        return "Scope";
      
      case ProviderTefEnum.SITEF:
        return "SITEF";

      case ProviderTefEnum.VBI:
        return "VBI";
    }
  }

  cleanObject(obj: any): any {
    if (Array.isArray(obj)) {
      const cleanedArray = obj
        .map(item => this.cleanObject(item))
        .filter(item => item !== undefined && !(Array.isArray(item) && item.length === 0));
      return cleanedArray.length > 0 ? cleanedArray : undefined;
    } else if (obj !== null && typeof obj === 'object') {
      const cleanedObj: any = {};
      for (const key of Object.keys(obj)) {
        const cleanedValue = this.cleanObject(obj[key]);
        if (
          cleanedValue !== undefined &&
          !(Array.isArray(cleanedValue) && cleanedValue.length === 0)
        ) {
          cleanedObj[key] = cleanedValue;
        }
      }
      return Object.keys(cleanedObj).length > 0 ? cleanedObj : undefined;
    } else if (obj !== null) {
      return obj;
    } else {
      return undefined;
    }
  }



}
